
import {
    defineComponent,
    ref,
    onMounted
} from 'vue'

//services
import Bitacora from "@/core/services/BitacoraService"
import {
    errManager
} from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
export default defineComponent({
    name: "tutoriales",
    setup() {
        const { t } = useI18n();
        const loading = ref(false)
        const listTutorials = ref<any[]>([])

        const getTutorials = async () => {
            Bitacora.Tutoriales()
                .then((res) => {
                    loading.value = false
                    listTutorials.value = res.data
                }).catch(({
                    response
                }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        onMounted(() => {
            getTutorials()
        })

        return {
            t,
            loading,
            listTutorials,
            getTutorials
        }

    },
})
